import script from "./RescheduleClass.vue?vue&type=script&setup=true&lang=js"
export * from "./RescheduleClass.vue?vue&type=script&setup=true&lang=js"

import "./RescheduleClass.vue?vue&type=style&index=0&id=1348f356&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1348f356"]])

export default __exports__